<template>
  <div>
    <template>
      <v-card class="elevation-5 mb-4 px-5 py-3" lg8>
        <v-layout row wrap align-center justify-start>
          <h1
            class="subheading font-weight-black primary--text mr-4"
            :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
          >
            Filtrar por data:
          </h1>
          <v-flex xs12 sm3 class="px-2">
            <v-select
              item-text="descricao"
              item-value="id"
              label="Competência"
              v-model="semestre"
              :clearable="true"
              :items="semestres"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="px-2">
            <v-select
              item-text="mes"
              item-value="id"
              label="Mês Atendimento"
              v-model="mesAtendimento"
              :clearable="true"
              :items="meses"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="px-2">
            <h2
              class="subheading mr-4"
              :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
            >
              Valor Total:
              {{
                listDespesas
                  ? listDespesas.reduce((a, b) => a + b.valorPagoPrestador, 0)
                  : 0 | currency
              }}
            </h2>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-card>
    </template>
    <v-data-table
      class="elevation-5"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers[tipo]"
      :items="listDespesas"
      :loading="isLoading"
      :rows-per-page-items="pageOptions"
    >
      <template v-slot:items="props">
        <td>{{ props.item.codigoProcedimento }}</td>
        <td>{{ props.item.descricaoProcedimento }}</td>
        <td>{{ props.item.nomeRazaoExecutante }}</td>
        <td>{{ props.item.cpfCnpjExecutante }}</td>
        <td v-if="tipo < 3">{{ props.item.especialidadeMedica }}</td>
        <td>{{ props.item.dataAtendimento | formatDate }}</td>
        <td v-if="tipo === 3">
          {{ props.item.dataFinalInternacao | formatDate }}
        </td>
        <td>{{ props.item.quantidadeExecutada }}</td>
      </template>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} de
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { getHistoricoUtilizacoes } from "@/services/beneficiario";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "HistoricoUtilizacaoAbaItem",
  props: {
    tipo: Number
  },
  computed: {
    ...mapState(["dadosBeneficiario"]),
    beneficiarioCartao() {
      return this.dadosBeneficiario.id;
    }
  },
  data() {
    const currentYear = new Date().getFullYear();
    const range = (start, stop, step) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    const anos = range(currentYear, currentYear - 5, -1);
    const semestres = [];
    for (const ano of anos) {
      semestres.push({
        id: ano + "2",
        descricao: "2º semestre de " + ano
      });
      semestres.push({
        id: ano + "1",
        descricao: "1º semestre de " + ano
      });
    }
    return {
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      active: null,
      competenciaDe: null,
      competenciaAte: null,
      mesAtendimento: null,
      semestre: null,
      tipoDespesa: null,
      dialog: false,
      isLoading: false,
      semestres: semestres,
      listDespesas: [],
      meses: [
        { id: 1, mes: "Janeiro" },
        { id: 2, mes: "Fevereiro" },
        { id: 3, mes: "Março" },
        { id: 4, mes: "Abril" },
        { id: 5, mes: "Maio" },
        { id: 6, mes: "Junho" },
        { id: 7, mes: "Julho" },
        { id: 8, mes: "Agosto" },
        { id: 9, mes: "Setembro" },
        { id: 10, mes: "Outubro" },
        { id: 11, mes: "Novembro" },
        { id: 12, mes: "Dezembro" }
      ],
      headers: [
        [],
        [
          { text: "Código", value: "codigoProcedimento", sortable: false },
          {
            text: "Descrição Consulta",
            value: "descricaoProcedimento",
            sortable: false
          },
          {
            text: "Nome do Prestador",
            value: "nomeRazaoExecutante",
            sortable: false
          },
          {
            text: "CPF/CNPJ",
            value: "cpfCnpjExecutante",
            sortable: false
          },
          {
            text: "Especialidade",
            value: "especialidadeMedica",
            sortable: false
          },
          {
            text: "Data Realização",
            value: "dataAtendimento",
            sortable: false
          },
          { text: "Quantidade", value: "quantidadeExecutada", sortable: false }
        ],
        [
          { text: "Código", value: "codigoProcedimento", sortable: false },
          {
            text: "Descrição Procedimento",
            value: "descricaoProcedimento",
            sortable: false
          },
          {
            text: "Nome do Prestador",
            value: "nomeRazaoExecutante",
            sortable: false
          },
          {
            text: "CPF/CNPJ",
            value: "cpfCnpjExecutante",
            sortable: false
          },
          {
            text: "Especialidade",
            value: "especialidadeMedica",
            sortable: false
          },
          {
            text: "Data Realização",
            value: "dataAtendimento",
            sortable: false
          },
          { text: "Quantidade", value: "quantidadeExecutada", sortable: false }
        ],
        [
          { text: "Código", value: "codigoProcedimento", sortable: false },
          {
            text: "Descrição",
            value: "descricaoProcedimento",
            sortable: false
          },
          {
            text: "Nome do Prestador",
            value: "nomeRazaoExecutante",
            sortable: false
          },
          {
            text: "CPF/CNPJ",
            value: "cpfCnpjExecutante",
            sortable: false
          },
          { text: "Data Inicial", value: "dataAtendimento", sortable: false },
          { text: "Data Final", value: "dataFinalInternacao", sortable: false },
          { text: "Quantidade", value: "quantidadeExecutada", sortable: false }
        ],
        [
          { text: "Código", value: "codigoProcedimento", sortable: false },
          {
            text: "Descrição Procedimento",
            value: "descricaoProcedimento",
            sortable: false
          },
          {
            text: "Nome do Prestador",
            value: "nomeRazaoExecutante",
            sortable: false
          },
          {
            text: "CPF/CNPJ",
            value: "cpfCnpjExecutante",
            sortable: false
          },
          {
            text: "Data Realização",
            value: "dataAtendimento",
            sortable: false
          },
          { text: "Quantidade", value: "quantidadeExecutada", sortable: false }
        ]
      ]
    };
  },
  watch: {
    beneficiarioCartao: {
      handler() {
        this.historicoUtilizacao();
      }
    },
    semestre: {
      handler(semestreValue) {
        this.competenciaDe = null;
        this.competenciaAte = null;

        if (semestreValue) {
          const ano = semestreValue.substring(0, 4);
          const semestre = semestreValue.substring(4, 5);
          this.competenciaDe = Number(ano + (semestre === "1" ? "01" : "07"));
          this.competenciaAte = Number(ano + (semestre === "1" ? "06" : "12"));
        }

        this.historicoUtilizacao();
      }
    },
    mesAtendimento: {
      handler() {
        this.historicoUtilizacao();
      }
    }
  },
  created() {
    this.historicoUtilizacao();
  },
  methods: {
    ...mapMutations(["setErrorToast"]),
    async historicoUtilizacao() {
      this.isLoading = true;
      this.listDespesas = await getHistoricoUtilizacoes(
        this.tipo,
        this.beneficiarioCartao,
        this.mesAtendimento,
        this.competenciaDe,
        this.competenciaAte
      )
        .then(({ data, errors }) => {
          if (errors && errors.length) {
            const errorMessage = errors[0].message.split(": ")[1];

            this.setErrorToast(errorMessage);
          } else {
            return data.historicoUtilizacoes;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
